import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { ITriageModel } from './types';

const triage: ITriageModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default triage;
